import { SoftHyphenInjector } from '../SoftHyphenInjector';
import { FontSizeVariants, LineHeightVariants, type OverlayRectangleType } from './types';

const styleHelperFontSize = (type: string) => {
  switch (type) {
    case 'big':
      return FontSizeVariants.Big;
    case 'medium':
      return FontSizeVariants.Medium;
    default:
      return FontSizeVariants.Small;
  }
};

const styleHelperLineHeight = (type: string) => {
  switch (type) {
    case 'big':
      return LineHeightVariants.Big;
    case 'medium':
      return LineHeightVariants.Medium;
    default:
      return LineHeightVariants.Small;
  }
};
/**
 * This component shows editorial content of a teaser.
 */
export const OverlayRectangleItem = ({ data }: { data: OverlayRectangleType }) => {
  const {
    field_headline: headline,
    field_text_subheadline: subHeadline,
    field_font: styleFont,
    field_font_subheadline: styleFontSubHeadline,
    field_negative_text_color: styleIsNegativeTextColor = false,
    field_size: styleSize = 'big',
    field_size_subheadline: styleSizeSubHeadline = 'small',
  } = data;

  return (
    <span className={styleIsNegativeTextColor ? 'text-color-text-light' : 'text-color-text-dark'}>
      {headline && (
        <span
          className={`headline block ${styleFont}`.trim()}
          style={{
            fontSize: styleHelperFontSize(styleSize),
            lineHeight: styleHelperLineHeight(styleSize),
          }}
        >
          <SoftHyphenInjector text={headline} />
        </span>
      )}
      {subHeadline && (
        <span
          className={`sub-headline mt-1 hidden md:block ${styleFontSubHeadline}`.trim()}
          style={{
            fontSize: styleHelperFontSize(styleSizeSubHeadline),
            lineHeight: styleHelperLineHeight(styleSizeSubHeadline),
          }}
        >
          <SoftHyphenInjector text={subHeadline} />
        </span>
      )}
      <span
        className={`text-size-headline-xl icon-emp-arrow-large-right absolute right-2 bottom-2 inline-block ${styleIsNegativeTextColor ? 'text-color-text-light fill-color-text-light' : 'text-color-text-dark fill-color-text-dark'}`}
      />
    </span>
  );
};
